import { UserProfile } from "src/types/user";

export const JOEXING_GROUP_ID = 4;

export function isJoeXingUser(userProfile: UserProfile | null) {
    return userProfile?.group_id === JOEXING_GROUP_ID;
}

